export default "__VITE_ASSET__4b7ae2ed__"